import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { AppointmentDataResponse } from '@utils/interfaces';
import { useOBQuery } from '@hooks/useOBQuery';

interface AppointmentDataProps {
  appointmentId: string | null;
}

const useGetAppointmentData = ({ appointmentId }: AppointmentDataProps) => {
  const url = useApiUrl(
    OBRoutes.Appointment,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.concat(`/${appointmentId}`);

  return useOBQuery<AppointmentDataResponse>(url, {
    enabled: !!appointmentId,
  });
};

export default useGetAppointmentData;
